module.exports = __webpack_public_path__ + "14320c7d07db44c115a7650cb86a20f7.png";


//////////////////
// WEBPACK FOOTER
// ./pages/yubashuo/img/favicon_b.png
// module id = 3
// module chunks = 0 2